import { z } from 'zod';
import { projectArtifactSchema } from './project-artifact.js';
const digest = z.string().regex(/^[a-f0-9]{64}$/);
const activityIdentity = z.object({
    // Internal disk/editor engine namespace; Field public APIs use engagementId/runtimeVersionId.
    domain: z.literal('field').optional(),
    workspaceId: z.uuid(),
    attemptId: z.uuid(),
    taskVersionId: z.uuid(),
});
export const prepareActivitySchema = activityIdentity
    .extend({ operationId: z.uuid(), artifact: projectArtifactSchema, artifactHash: digest })
    .strict();
export const workspaceContextSchema = activityIdentity
    .extend({ generation: z.number().int().positive() })
    .strict();
export const activityOperationSchema = workspaceContextSchema
    .extend({ operationId: z.uuid() })
    .strict();
export const excludedProjectFileSchema = z.object({
    path: z.string().max(1024),
    /** `oversized_file` appears only in read-only listings; a capture still fails on it. */
    reason: z.enum([
        'excluded_path',
        'unsupported_file',
        'symbolic_link',
        'special_file',
        'oversized_file',
    ]),
});
/** A stable disk capture. Editor-buffer acknowledgement is a separate required save barrier. */
export const activityCaptureSchema = activityOperationSchema
    .extend({
    version: z.literal(1),
    capturedAt: z.iso.datetime(),
    artifact: projectArtifactSchema,
    artifactHash: digest,
    excluded: z.array(excludedProjectFileSchema).max(500),
})
    .strict();
export const activityManifestSchema = activityIdentity
    .extend({
    version: z.literal(1),
    initializedAt: z.iso.datetime(),
    initialHash: digest,
    initialOperationId: z.uuid(),
})
    .strict();
export const runtimeStateSchema = z.object({ current: workspaceContextSchema.nullable() }).strict();
export const preparedActivitySchema = z.object({
    attemptId: z.uuid(),
    taskVersionId: z.uuid(),
    initialized: z.boolean(),
});
